import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Cash Flow Statement";
const description = `A cash flow statement is a vital financial report that tracks the actual cash coming in and going out of a business, categorized into three main activities: operating, investing, and financing. The Cash Flow from Operating Activities reveals if the core business is generating enough cash to sustain itself. The Cash Flow from Investing Activities shows how the business is using cash to acquire or sell long-term assets for future growth. Lastly, the Cash Flow from Financing Activities details how the company raises capital from and repays it to owners and creditors. This statement is crucial because it provides a clear picture of a company's liquidity, helping business owners and investors determine if the company can pay its bills, fund its growth, and manage its debt effectively.`;

const images = [
    '/images/reports/business-overview/cash-flow-statement/cash-flow-statement.png', // 0
];


const CashFlowStatement: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CashFlowStatement;
